export default "__VITE_ASSET__CSmXbT9Q__"